import React, { createContext, useState, useEffect } from 'react';

// api
import { getMe } from '@api/auth';

// types
import type { Me } from '@libs/types';

interface AuthContextType {
  user: Me | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (user: Me) => void;
  logout: () => void;
  checkAuth: () => Promise<Me | undefined>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

interface IProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: IProps) => {
  const [user, setUser] = useState<Me | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const userData = await getMe();

      setUser(userData);

      return userData;
    } catch (error) {
      console.error('Fetch me info error: ', error);

      setUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = (userData: Me) => {
    setUser(userData);
  };

  const logout = async () => {
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } finally {
      setUser(null);
    }
  };

  const value = {
    user,
    isAuthenticated: !!user,
    isLoading,
    login,
    logout,
    checkAuth,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
